var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDescarcator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 95,
    viewBox: "0 0 96 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.75,
    y: 83.75,
    width: 73.9815,
    height: 26.5,
    transform: "rotate(-90 34.75 83.75)",
    stroke: "black",
    strokeWidth: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 22.4766L48 2.0032",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2929 31.7071C47.6834 32.0976 48.3166 32.0976 48.7071 31.7071L55.0711 25.3431C55.4616 24.9526 55.4616 24.3195 55.0711 23.9289C54.6805 23.5384 54.0474 23.5384 53.6569 23.9289L48 29.5858L42.3431 23.9289C41.9526 23.5384 41.3195 23.5384 40.9289 23.9289C40.5384 24.3195 40.5384 24.9526 40.9289 25.3431L47.2929 31.7071ZM47 21L47 31L49 31L49 21L47 21Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescarcator);
export default __webpack_public_path__ + "static/media/descarcator.f5d604da5a7a8898a66c7e03f17fa7fe.svg";
export { ForwardRef as ReactComponent };